import ParamTables from "./param-tables";
export default ParamTables;
